import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '[data-component="inset-cta"]' ).forEach( ( component ) => {
        const pills = component.querySelectorAll( '.js-inset-cta-pill' );
        const content = component.querySelector( '.inset-cta__content' );

        if ( !pills.length ) return;

        if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
          gsap.set( pills, {autoAlpha: 1, y: 0} );
          return;
        }

        gsap.fromTo(
            pills,
            {
              autoAlpha: 0,
              y: 24,
            },
            {
              autoAlpha: 1,
              y: 0,
              duration: 1,
              stagger: 0.1,
              delay: 0.8,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: content || component,
                start: 'top 85%',
                once: true,
              },
            },
        );
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'inset-cta', COMPONENT );
} )( app );
